import { z } from 'zod/v4';
export const refreshesSchema = z.object({
    used: z.number(),
    remaining: z.number(),
    limit: z.number(),
});
export const dailyAddedSchema = z.object({
    used: z.number(),
    remaining: z.number(),
    limit: z.number(),
});
export const aiVisibilityCreditsSchema = z.object({
    used: z.number(),
    remaining: z.number(),
    limit: z.number(),
});
export const permissionsSchema = z.object({
    on_demand_updates: z.boolean(),
    unlimited_domains: z.boolean(),
    customer_support: z.boolean(),
    api_access: z.boolean(),
    unlimited_add_ons: z.boolean(),
    share_of_voice: z.boolean(),
    serp_history: z.boolean(),
    mobile_tracking: z.boolean(),
    spyglass: z.boolean(),
    suggestions: z.boolean(),
    search_intent: z.boolean(),
    serp_features: z.boolean(),
    custom_alerts: z.boolean(),
    local_rank_tracking: z.boolean(),
    viewkey_reports: z.boolean(),
    custom_viewkey_domain: z.boolean(),
    scheduled_reports: z.boolean(),
    google_integrations: z.boolean(),
    dashthis_integration: z.boolean(),
});
export const tiersDetailSchema = z.object({
    range: z.string(),
    unit_price: z.string(),
    quantity_used: z.number(),
    subtotal: z.string(),
});
export const discountSchema = z.object({
    coupon_id: z.string(),
    amount_off: z.string(),
    percent_off: z.null(),
});
export const billingDetailsSchema = z.object({
    id: z.number(),
    user_id: z.number(),
    country: z.string(),
    countrystate: z.string(),
    city: z.string(),
    company: z.string(),
    street: z.string(),
    suite: z.null(),
    tax_id_type: z.string(),
    tax_id: z.string(),
    postal_code: z.string(),
    created_at: z.string(),
    updated_at: z.string(),
});
export const defaultCardSchema = z.object({
    type: z.string(),
    brand: z.string(),
    exp_month: z.number(),
    exp_year: z.number(),
    last4: z.string(),
    address_line1: z.null(),
    address_line2: z.null(),
    address_city: z.null(),
    address_state: z.null(),
    address_zip: z.null(),
    address_country: z.null(),
});
export const latestInvoiceSchema = z.object({
    id: z.string(),
    number: z.string().nullable(),
    status: z.string().nullable(),
    billing_reason: z.string().nullable(),
    amount_due: z.number(),
    amount_paid: z.number(),
    total: z.number(),
    is_trial_invoice: z.boolean(),
    requires_action: z.boolean(),
    is_overdue: z.boolean(),
});
export const packageInfoSchema = z.object({
    title: z.string(),
});
export const data2Schema = z.object({
    type: z.string(),
    id: z.string(),
});
export const data3Schema = z.object({
    type: z.string(),
    id: z.string(),
});
export const pdfSchema = z.object({
    show_columns: z.array(z.string()),
    historical_chart: z.boolean(),
    company_info: z.boolean(),
    verified_by: z.boolean(),
    date: z.boolean(),
});
export const widthsSchema = z.object({
    start: z.number(),
    gpage: z.number(),
    best: z.number(),
    g: z.number(),
    day: z.number(),
    week: z.number(),
    month: z.number(),
    life: z.number(),
    clicks: z.number(),
    impressions: z.number(),
    ctr: z.number(),
    ms: z.number(),
    cpc: z.number(),
    competition: z.number(),
    comp: z.number(),
    tags: z.number(),
    timestamp: z.number(),
    near: z.number(),
    gmb: z.number(),
    source: z.number(),
    kw: z.number(),
});
export const sortingSchema = z.object({
    sort_by: z.string(),
    sort_by_order: z.string(),
    category_sort: z.null(),
});
export const emailReportsSchema = z.object({
    emailsubject: z.null(),
    emailbody: z.null(),
    reportname: z.string(),
    mailfrom: z.null(),
    mailsendername: z.null(),
    monitorenabled: z.boolean(),
    emailmonitor: z.null(),
});
export const viewkeySettingsSchema = z.object({
    company_name: z.null(),
    company_url: z.null(),
    company_logo: z.null(),
    company_desc: z.null(),
});
export const projectMetricsSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const keywordsInTopSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const sovSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const distributionSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const visibilitySchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const estimatedTrafficSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const topPagesSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const organicTrafficAcquisitionSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const serpFeaturePerformanceSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const keywordsByIntentSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const averageRankSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const visibilityAndEstimatedTrafficSchema = z.object({
    visible: z.boolean(),
    order: z.number(),
});
export const subscriptionSchema = z.object({
    cancel_at_period_end: z.boolean(),
    cancel_at: z.null(),
    status: z.string(),
    package_name: z.string(),
    package_identity: z.string(),
    stripe_active: z.boolean(),
    is_downgrade_planned: z.boolean(),
    account_expire_at: z.string(),
    next_billing_at: z.string(),
    next_billing_at_ts: z.number(),
    ends_at: z.null(),
    billing_cycle: z.string(),
    package: z.number(),
    currentpay: z.number(),
    nextpay: z.number(),
    dailyadded: z.number(),
    refreshed: z.number(),
    apicredits: z.number(),
    cycle: z.string(),
    payer_email: z.null(),
    active: z.number(),
    stripe_id: z.string(),
    stripe_package_amount: z.string(),
    stripe_plan_amount: z.string(),
    total_discount: z.number(),
    coupon: z.string(),
    trial_period: z.number(),
    initial_trial_period: z.number(),
    permissions: permissionsSchema,
    is_free_plan: z.boolean(),
    price_type: z.string(),
});
export const aiSearchCreditsTieredSchema = z.object({
    cancel_at_period_end: z.boolean(),
    cancel_at: z.null(),
    status: z.string(),
    next_billing_at: z.string(),
    next_billing_at_ts: z.number(),
    ends_at: z.null(),
    credits: z.number(),
    unit_price: z.string(),
    total_before_discount: z.string(),
    final_price: z.string(),
    tiers_details: z.array(tiersDetailSchema),
    discount: discountSchema,
    schedule: z.array(z.null()),
});
export const subscriptionsSchema = z.object({
    data: data2Schema,
});
export const settingsSchema = z.object({
    data: data3Schema,
});
export const tableColumnsSchema = z.object({
    widths: widthsSchema,
});
export const projectOverviewSettingsSchema = z.object({
    project_metrics: projectMetricsSchema,
    keywords_in_top: keywordsInTopSchema,
    sov: sovSchema,
    distribution: distributionSchema,
    visibility: visibilitySchema,
    estimated_traffic: estimatedTrafficSchema,
    top_pages: topPagesSchema,
    organic_traffic_acquisition: organicTrafficAcquisitionSchema,
    serp_feature_performance: serpFeaturePerformanceSchema,
    keywords_by_intent: keywordsByIntentSchema,
    average_rank: averageRankSchema,
    visibility_and_estimated_traffic: visibilityAndEstimatedTrafficSchema,
});
export const addonSubscriptionsSchema = z.object({
    AI_SEARCH_CREDITS_TIERED: aiSearchCreditsTieredSchema,
});
export const relationshipsSchema = z.object({
    subscriptions: subscriptionsSchema,
    settings: settingsSchema,
});
export const attributes2Schema = z.object({
    name: z.string().optional(),
    plan_name: z.string().optional(),
    active: z.boolean().optional(),
    valid: z.boolean().optional(),
    recurring: z.boolean().optional(),
    ontrial: z.boolean().optional(),
    ongrace: z.boolean().optional(),
    trial_ends_at: z.string().optional(),
    ends_at: z.null(),
    created_at: z.string().optional(),
    updated_at: z.string().optional(),
    pdf: pdfSchema.optional(),
    hidecolumns: z.string().optional(),
    table_columns: tableColumnsSchema.optional(),
    chartPeriod: z.number().optional(),
    categorysort: z.null(),
    chartheight: z.number().optional(),
    display_length: z.number().optional(),
    alert_emails: z.array(z.null()).optional(),
    alert_meat: z.number().optional(),
    metrics: z.string().optional(),
    metrics_range: z.array(z.string()).optional(),
    sorting: sortingSchema.optional(),
    email_reports: emailReportsSchema.optional(),
    invoicedetails: z.null(),
    viewkey_settings: viewkeySettingsSchema.optional(),
    timezone: z.null(),
    dateformat: z.null(),
    currency_code: z.string().optional(),
    newsletter_subscription: z.boolean().optional(),
    project_overview_settings: projectOverviewSettingsSchema.optional(),
    hide_overview: z.boolean().optional(),
});
export const attributesSchema = z.object({
    user_is_restricted: z.boolean(),
    onboarding: z.boolean(),
    verified: z.number(),
    user_id: z.number(),
    intercom_hash: z.string(),
    intercom_user_id: z.string(),
    name: z.null(),
    addon_master_email: z.string(),
    addon_master_disabled: z.boolean(),
    addon_restricted: z.boolean(),
    api_token: z.string(),
    showall: z.string(),
    sharedcountapi: z.string(),
    access_level: z.string(),
    gsc_connected: z.boolean(),
    used: z.number(),
    package: z.number(),
    refreshes: refreshesSchema,
    daily_added: dailyAddedSchema,
    ai_visibility_credits: aiVisibilityCreditsSchema,
    contactnum: z.null(),
    contactnum_code: z.null(),
    country: z.string(),
    countrystate: z.null(),
    last_login_at: z.string(),
    created_at: z.string(),
    created_at_ts: z.number(),
    disabled: z.boolean(),
    is_not_stripe_user: z.boolean(),
    is_free_plan: z.boolean(),
    currency_code: z.string(),
    serp_and_ranking_history_limit_date: z.string(),
    trial_is_used: z.boolean(),
    subscription: subscriptionSchema,
    addon_subscriptions: addonSubscriptionsSchema,
    billing_details: billingDetailsSchema,
    default_card: defaultCardSchema,
    latest_invoice: latestInvoiceSchema,
    package_info: packageInfoSchema,
});
export const includedSchema = z.object({
    type: z.string(),
    id: z.string(),
    attributes: attributes2Schema,
});
export const dataSchema = z.object({
    type: z.string(),
    id: z.string(),
    attributes: attributesSchema,
    relationships: relationshipsSchema,
});
export const usersSelfSchema = z.object({
    data: dataSchema,
    included: z.array(includedSchema),
});
